// eslint-disable-next-line import/default
import get from "lodash.get"

export const groupBy = (array: any[], groupKey: string): any[] =>
  array.reduce((acc, cur) => {
    const currentKey = acc.find((keys: any) => get(keys, groupKey) === get(cur, groupKey))
    // TODO: переделать на сравнение обьектов https://lodash.com/docs/4.17.15#isEqual
    const [key] = groupKey.split(".")

    if (currentKey === undefined) {
      if (cur[key] !== null) {
        acc.push({ items: [cur], [key]: cur[key] })
      }
    } else {
      currentKey.items.push(cur)
    }

    return acc
  }, [])
